import { TruckTypeEnum } from '@/types/graphql/schemaTypes';
import { SelectOption } from '@/types/types';

export default function truckOptions(): SelectOption<string>[] {
  return [
    TruckTypeEnum.unknown,
    TruckTypeEnum.small_truck,
    TruckTypeEnum.flat_2t,
    TruckTypeEnum.wing_2t,
    TruckTypeEnum.unic_2t,
    TruckTypeEnum.flat_4t,
    TruckTypeEnum.wing_4t,
    TruckTypeEnum.unic_4t,
    TruckTypeEnum.flat_10t,
    TruckTypeEnum.wing_10t,
    TruckTypeEnum.unic_10t,
    TruckTypeEnum.flat_trailer_20t,
    TruckTypeEnum.wing_trailer_20t,
    TruckTypeEnum.other
  ].map((val: TruckTypeEnum) => { return { value: val, label: `trucking.${val}` }; });
}
